import { Box, Button, Container, List, Typography } from "@mui/material";
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useQuery } from "@tanstack/react-query";
import { MyAppBar } from "../components/Home/MyAppBar/myAppBar";
import { MyProjectItem } from "../components/User/Profile/myProjectsItem";
import AddIcon from '@mui/icons-material/Add';
import { PublicProjectsSearch } from "../components/Project/publicProjectsSearch";
import { PublicProjectItem } from "../components/Project/publicProjectsItem";
import { LoadingCircle } from "../components/loading";

export const PublicProjects = () => {
    const { data: projects, isLoading, isError } = useQuery({
        queryKey: ["loadmyprojects"], queryFn: async () => {
            const q = query(collection(db, "project"), where("ispublic", "==", true));
            const data = await getDocs(q)
            const filteredData = data.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id
            }));
            return filteredData;
        }
    });

    if (isLoading) return (
        <>
            <MyAppBar></MyAppBar>
            <Container maxWidth="md">
                <LoadingCircle />
            </Container>
        </>
    )

    if (isError) return (
        <>
            <MyAppBar></MyAppBar>
            <Container maxWidth="md">
                <Typography>Ou ... Can't load public projects :(</Typography>
            </Container>
        </>
    )

    return (
        <>
            <MyAppBar></MyAppBar>
            <Container maxWidth="md" sx={{ pt: 10 }}>
                <div >
                    <p>
                        <Typography variant="h3">Public projects</Typography></p>
                    {/* <p>
                        <p>
                            <PublicProjectsSearch></PublicProjectsSearch>
                        </p>
                    </p>
                    <div>
                        <List>
                            {projects?.map((value) => (
                                <PublicProjectItem project={value} />
                            ))}
                        </List>
                    </div> */}
                <Typography variant="h5" color="text.secondary" sx={{ mt: 2, mb: 2 }}>
                    Coming soon
                </Typography>
                </div>
            </Container>
        </>
    );
};